// Client-visible config. ONLY VITE_-prefixed vars are exposed to the browser.
// Service-role, AI, push REST, and email secrets are never referenced here.

export const config = {
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL as string,
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY as string,
  appUrl: (import.meta.env.VITE_PUBLIC_APP_URL as string) ?? window.location.origin,
  oneSignalAppId: (import.meta.env.VITE_ONESIGNAL_APP_ID as string) ?? "",
};
